import { useContext } from 'react'
import { AppStateContext } from '../../state/AppProvider'
import { SuggestedQuestion, SuggestedQuestionsCard } from '../Cards'
import { Carousel } from '../Carousel'
import styles from './CardsCarousel.module.css'

interface CardsCarouselProps {
  onQuestionClick: (question: string) => void
  allQuestions: SuggestedQuestion[]
}

const CARD_WIDTH = 210
const CARD_GAP = 16

export const CardsCarousel = ({ onQuestionClick, allQuestions }: CardsCarouselProps) => {
  const appStateContext = useContext(AppStateContext)
  const cardsPerSlide = appStateContext?.state.currentChat?.extended_data.experiment_form_expanded ? 2 : 4

  return (
    <Carousel
      items={allQuestions}
      cardsPerSlide={cardsPerSlide}
      cardWidth={CARD_WIDTH}
      cardGap={CARD_GAP}
      keyExtractor={(question, index) => `${question.agent}-${index}`}
      renderItem={(question) => (
        <SuggestedQuestionsCard question={question} onClick={onQuestionClick} />
      )}
      className={styles.carouselContainer}
    />
  )
}
